import React from 'react';

export default function TenantTags ({ tagIds, tagsById, className = 'mt-1', }) {
  const tags = (tagIds ?? []).map(tagId => tagsById[tagId]).filter(_ => _);
  if(tags.length === 0) return null;

  return (
    <div className={className}>
      {
        tags.map(_ => (
          <span key={_.id} className="badge badge-secondary mr-1">{_.name}</span>
        ))
      }
    </div>
  );
};
